var render = function render(){var _vm=this,_c=_vm._self._c;return _c('commonSelect',{attrs:{"value":_vm.value,"multiple":_vm.multiple,"placeholder":"请选择部门","idKey":"DpId","labelKey":"DpName","get-data-func":_vm.getDataFunc},on:{"input":v=>_vm.$emit('input',v),"change":v=>_vm.$emit('change',v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }